import React from 'react';
import Hero from './Hero';

const keyMeasuresData = [
  {
    title: 'BUSINESS PLAN',
    subtitle: 'Is the farmer having a business plan? Does he manage using the plan?',
    plan: 'Δ 10%',
    actual: '+33%',
    num: '655'
  },
  {
    title: 'CONTRACTS',
    subtitle: 'How many contracts does the farmer have?',
    plan: 'Δ 10%',
    actual: '+33%',
    num: '655'
  },
  {
    title: 'INVOICES',
    subtitle: 'How many invoices and delivery notes are done using the App?',
    plan: 'Δ 10%',
    actual: '+33%',
    num: '655'
  },
  {
    title: 'OVERDUE PAYMENTS',
    subtitle: 'Are payments made on time? How much is overdue?',
    plan: 'Δ 10%',
    actual: '+33%',
    num: '655'
  },
  {
    title: 'TRANSACTIONS',
    subtitle: 'How many transactions are done using integrated payment?',
    plan: 'Δ 10%',
    actual: '+33%',
    num: '655'
  },
  {
    title: 'SUPPLIER PINGS',
    subtitle: 'How many times do suppliers ping to follow up on payment?',
    plan: 'Δ 10%',
    actual: '+33%',
    num: '55'
  },
  {
    title: 'RATINGS & REVIEWS',
    subtitle: 'How many invoices and delivery notes are done using the App?',
    plan: 'Δ 10%',
    actual: '+33%',
    num: '655'
  },
  {
    title: 'COMMUNITIES',
    subtitle: 'How is the performance of the communities the farmer is in?',
    plan: 'Δ 10%',
    actual: '+33%',
    num: '55'
  },
  {
    title: 'SUPPORT',
    subtitle: 'How responsive is support to the farmer’s queries?',
    plan: 'Δ 10%',
    actual: '+33%',
    num: '100'
  }
];

const BusinessPlans = () => {
  return (
    <div className='px-4 md:px-24 pt-4'>
      <Hero />

      <div className="flex justify-between md:mt-5 mt-2 mb-6 md:flex-row">
        <h2 className="text-[10px] md:text-[24px] font-bold text-[#03897B]">
          ENTERPRENEUR
        </h2>
        <h1 className="md:text-[24px] text-[8px] font-bold text-black mt-1 md:mt-0">
          ABC Enterprise | ID NO: XXXXXXXX01
        </h1>
      </div>

      <div className='flex justify-end -mt-4'>
        <img
          src='https://res.cloudinary.com/dzngpgki4/image/upload/v1746284935/image_951_wb43l7.png'
          alt=''
          className='md:h-[44px] md:w-[64px] h-6 w-10'
        />
      </div>

      <h2 className="text-[10px] md:text-[24px] font-bold text-[#03897B] mb-5 md:-mt-5">
        CREDIT SCORE
      </h2>

      <div>
        <div className='flex flex-col gap-y-2'>
          <div className='flex md:flex-row '>
            <div className="w-[430px] md:w-[650px]">
              <h3 className="text-[8px] md:text-[24px] font-bold leading-tight ml-1 md:ml-4">
                RISK GRADE
              </h3>
            </div>
            <div className="w-full md:w-[320px] text-[8px] md:text-[24px] font-bold">
              Credit score
            </div>
            <div className="w-full md:w-[314px] text-[8px] md:text-[24px] font-bold">
              Description
            </div>
          </div>

          <div className="flex md:flex-row  gap-2">
            <div className="bg-[#E7EBEB] flex items-center rounded-[5px]  w-[390px] md:w-[615px] h-[35px] md:h-[78px] p-2 md:p-4">
              <h3 className="text-[8px] md:text-[24px] font-bold">B3</h3>
            </div>
            <div className="bg-[#CFD7D7] w-full md:w-[311px] h-[35px] md:h-[78px] flex items-center justify-center text-[8px] md:text-[24px] font-bold">
              655
            </div>
            <div className="bg-[#9FAFAF] w-[400px] md:w-[314px] h-[35px] md:h-[78px] flex items-center justify-center text-white text-[8px] md:text-[24px] font-bold">
              Low risk
            </div>
          </div>
        </div>

        <div className="md:mt-6 mt-3">
          <div className='flex md:flex-row '>
            <div className="w-[430px] md:w-[650px]">
              <h3 className="text-[8px] md:text-[24px] font-bold leading-tight ml-1 md:ml-4">
                Key Measures
              </h3>
            </div>
            <div className="w-full md:w-[320px] text-[8px] md:text-[24px] font-bold">
              Plan
            </div>
            <div className="w-full md:w-[314px] text-[8px] md:text-[24px] font-bold">
              Actual
            </div>
          </div>

          {keyMeasuresData.map((item, index) => (
            <div key={index}>
              <div className="flex md:flex-row gap-2 mt-2">
                <div className="bg-[#E7EBEB] flex items-center rounded-[5px] w-[400px] md:w-[615px] h-[35px] md:h-[78px] p-2 md:p-4">
                  <h3 className="text-[8px] md:text-[24px] font-bold">{item.title}</h3>
                </div>
                <div className="bg-[#CFD7D7] w-full md:w-[311px] h-[35px] md:h-[78px] flex items-center justify-center text-[8px] md:text-[24px] font-bold">
                  {item.plan}
                </div>
                <div className="bg-[#9FAFAF] w-full md:w-[314px] h-[35px] md:h-[78px] text-white px-2 text-[8px] md:text-[24px] font-bold flex flex-col justify-center">
                  <p className='text-center mt-2'>{item.actual}</p>
                  <p className='text-end font-normal italic text-[8px] md:text-[24px] -mt-2 md:-mt-5'>{item.num}</p>
                </div>
              </div>
              <p className="text-[10px] md:text-[24px] leading-snug mt-1 mb-2">{item.subtitle}</p>
            </div>
          ))}
        </div>
      </div>

      <div className='flex gap-4 items-center mt-10'>
  <div
      className="md:w-16 md:h-[63px]  w-6 h-[30px] rounded-[5px] bg-[#D9D9D9] flex items-center justify-center"
    >
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690778/Check_round_fill_ipswvy.png"
        alt="Check"
        className="md:w-[54px] md:h-[54px] w-[20px] h-[20px]"
      />
    </div>
    
    <p className="md:text-[20px]  text-[6px]  ">
        By ticking I confirm that I agree with the{" "}
        <span className="underline">Terms and conditions</span>, <span className='underline'>Data </span>and{" "}
        <span className="underline">Privacy policy</span>.
      </p>
  </div>

 
      <div className="flex md:gap-4 gap-1 justify-end md:mt-5 mt-2 md:mb-10 mb-5 flex-wrap">
      

        <a href='/BusinessPlan1'>
          <div>
            <button className="flex items-center justify-between md:w-[230px] w-[100px] md:h-[61px] h-[20px] bg-[#03897B] text-white md:text-[14px] text-[6px] font-bold rounded-[10px] px-4">
              <span>SEND</span>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746037449/Send_hor_fill_lfkysb.png"
                alt="Send Icon"
                className="md:w-[35px] md:h-[38px] w-2 h-2"
              />
            </button>
            <p className='md:text-[14px] text-[6px] md:mt-4 mt-1 font-normal md:px-1'>
              Send Due diligence form
            </p>
          </div>
        </a>
      </div>
    </div>
  );
};

export default BusinessPlans;
